<template>
<div class="">
    <div class="form-content-block group"
        v-bind:class="pageViews.enable_behavior ? '' : 'disabled'">
        <label class="input-label">
            <input type="checkbox" class="" v-model="pageViews.enable_behavior" /> Select page view trigger</label>
        <div class="row">
            <label class="label input-label">Page views</label>
            <label class="input-label label">greater than</label>
            <div class="control">
                <input
                :readonly="pageViews.enable_behavior ? false : true"
                type="text"
                class="input -inline"
                v-model="pageViews.behavior_value"/>
            </div>
        </div>
    </div> 
    <div class="row">
        <div class="control radio-field-control">
            <label for="radio-pageviews-logical-operator-and" class="radio input-label">
                <input
                    type="radio"
                    id="radio-pageviews-logical-operator-and"
                    value="and"
                    v-model="pageViews.behavior_logical_operator" />
                and
            </label>
            <label
                for="radio-pageviews-logical-operator-or"
                class="radio input-label">
                <input  type="radio"
                    id="radio-pageviews-logical-operator-or"
                    value="or"
                    v-model="pageViews.behavior_logical_operator" />
                or
            </label>
        </div>
    </div>
    <div class="form-content-block group"
        v-bind:class="visitDurations.enable_behavior ? '' : 'disabled'">
        <label class="input-label">
            <input  type="checkbox"
                class=""
                v-model="visitDurations.enable_behavior" />
            Select visit duration trigger
        </label>
        <div class=""
            v-for="(entry, index) in visitDurations.durations"
            :key="index">
            <div class="columns row">
                <div class="column">
                        <div class="control">
                            <select v-model="entry.behavior_subtype" :disabled="true"
                                class="select">
                                <option
                                    v-for="subbehavior in subbehaviors"
                                    :key="subbehavior.value"
                                    :value="subbehavior.value">
                                    {{ subbehavior.name }}
                                </option>
                            </select>
                        </div>     
                </div>
                <label class="label input-label">greater or equal to</label>
                <div class="column behavior-value">
                    <div class="field">
                        <div class="control">
                            <input  type="text"
                                class="input -inline"
                                v-model="entry.behavior_value"/>
                            
                        </div>
                    </div>
                </div>
            </div>
            <div class="row" v-if="entry.behavior_subtype == 'secondsOnPage'">
                <div class="control radio-field-control ">
                    <label
                        for="radio-subbehavior-and"
                        class="radio input-label">
                        <input
                            type="radio"
                            id="radio-subbehavior-and"
                            value="and"
                            v-model="entry.behavior_logical_operator"/>
                        and
                    </label>
                    <label
                        for="radio-subbehavior-or"
                        class="radio input-label">
                        <input
                            type="radio"
                            id="radio-subbehavior-or"
                            value="or"
                            v-model="entry.behavior_logical_operator"/>
                        or
                    </label>
                </div>
            </div>
        </div>
    </div>
</div>
</template>
<script>
import { isEmpty } from 'lodash';
import { initConversationBehavior } from './../scripts/init';

export default {
    name: 'Behavior',
    props: {
        entries: {
            required: true,
            type: Array
        }
    },
    computed: {
        pageViewBehavior() {
            let pageView = this.entries.find((entry) => entry.behavior_type === 'pageViews');
            if (pageView === undefined) {
                return {};
            }
            return {
                ...pageView,
                enable_behavior: true
            };
        },
        durationsBehavior() {
            let durations = this.entries.filter((entry) => entry.behavior_type === 'duration');
            return durations;
        },
        secondsOnPageBehavior() {
            if (!this.durationsBehavior.length) {
                return {};
            }
            const secondsOnPageEntry = this.durationsBehavior.find((entry) => {
                return entry.behavior_subtype === 'secondsOnPage'
            });
            return secondsOnPageEntry === undefined ? {} : secondsOnPageEntry;
        },
        secondsOnSiteBehavior() {
            if (!this.durationsBehavior.length) {
                return {};
            }
            const secondsOnSiteEntry = this.durationsBehavior.find((entry) => {
                return entry.behavior_subtype === 'secondsOnWebsite'
            });
            return secondsOnSiteEntry === undefined ? {} : secondsOnSiteEntry;
        }
    },
    data() {
        return {
            pageViews: {},
            visitDurations: {
                enable_behavior: false,
                durations: []
            },
            subbehaviors: {
                null: {
                    name: 'Select Duration on Site or Page',
                    value: ''
                },
                'secondsOnPage' : {
                    name: 'Seconds on Page',
                    value: 'secondsOnPage',
                },
                'secondsOnWebsite': {
                    name: 'Seconds on Website',
                    value: 'secondsOnWebsite'
                }
            }
        };
    },
    created() {
        this.initComponentData();
    },
    methods: {
        initComponentData() {
            this.pageViews = {
                ...this.getPageViewsDefaultEntry(),
                ...this.pageViewBehavior
            };
            
            if (isEmpty(this.secondsOnPageBehavior)) {
                this.visitDurations.durations.push(this.getDurationOnPageDefaultEntry());
            } else {
                this.visitDurations.durations.push(this.secondsOnPageBehavior);
            }

            if (isEmpty(this.secondsOnSiteBehavior)) {
                this.visitDurations.durations.push(this.getDurationOnSiteDefaultEntry());
            } else {
                this.visitDurations.durations.push(this.secondsOnSiteBehavior);
            }

            if (this.durationsBehavior.length) {
                this.visitDurations = {
                    ...this.visitDurations,
                    enable_behavior: true
                };
            }
        },
        collectData() {

            const behaviors = [];
            if (this.pageViews.enable_behavior) {
                behaviors.push(this.pageViews);
            }
            if (this.visitDurations.enable_behavior) {
                this.visitDurations.durations.forEach((entry) => {
                    behaviors.push(entry);
                });
            }
            
            this.$emit('updateBehavior', behaviors);
        },
        mergePageViews() {
            if (!isEmpty(this.pageViewBehavior)) {
                this.pageViews = {
                    ...this.pageViews,
                    enable_behavior: true
                };
            } else {
                this.pageViews = {
                    ...this.getPageViewsDefaultEntry()
                };
            }
        },
        mergeVisitDurations() {
            if (!this.durationsBehavior.length) {
                this.visitDurations.durations = [
                    this.getDurationOnPageDefaultEntry(),
                    this.getDurationOnSiteDefaultEntry()
                ];
                return;
            }
            if (!isEmpty(this.secondsOnSiteBehavior) && this.secondsOnSiteBehavior.conversation_behavior_id !== '') {
                this.visitDurations.durations.splice(1, 1, this.secondsOnSiteBehavior);
            } else {
                this.visitDurations.durations.splice(1, 1, this.getDurationOnSiteDefaultEntry());
            }

            if (!isEmpty(this.secondsOnPageBehavior) && this.secondsOnPageBehavior.conversation_behavior_id !== '') {
                this.visitDurations.durations.splice(0, 1, this.secondsOnPageBehavior);
            } else {
                this.visitDurations.durations.splice(0, 1, this.getDurationOnPageDefaultEntry());
            }

            if (this.durationsBehavior.length) {
                this.visitDurations = {
                    ...this.visitDurations,
                    enable_behavior: true
                };
            }
        },
        getPageViewsDefaultEntry() {
            const { data } = initConversationBehavior();
            return {
                ...data,
                behavior_type: 'pageViews',
                behavior_logical_operator: 'and'
            };
        },
        getDurationOnSiteDefaultEntry() {
            const { data } = initConversationBehavior();
            const entry = {
                ...data,
                behavior_type: 'duration',
                behavior_subtype: 'secondsOnWebsite'
            };
            return entry;
        },
        getDurationOnPageDefaultEntry() {
            const { data } = initConversationBehavior();
            const entry = {
                ...data,
                behavior_type: 'duration',
                behavior_subtype: 'secondsOnPage',
                behavior_logical_operator: 'and'
            };
            return entry;
        }
    },
    watch: {
        entries: {
            deep: true,
            handler(to, from) {
                if (to === undefined) {
                    return;
                }
                this.mergePageViews();
                this.mergeVisitDurations();
            }
        },
        pageViews: {
            deep: true,
            handler(to, from) {
                if (to === undefined || isEmpty(to)) {
                    return;
                }
                this.collectData();
            }
        },
        visitDurations: {
            deep: true,
            handler(to, from) {
                if (to === undefined || isEmpty(to)) {
                    return;
                }
                this.collectData();
            }
        }
    }
}
</script>
<style lang="scss" scoped>
@import "SrcRoot/modules/Campaign/components/setup/scss/setup.scss";
.form-content-block.group  {
    .input-label {
        display: flex;
        align-items: center;
        padding-top: 0px;
    }
    .label.input-label {
        padding-top:1.4rem;
    }

}
.control.radio-field-control {
    display:flex;
}

</style>
